import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateProgramReportComponent } from './create-program-report.component';
import { RolesGuard } from 'app/gaurds/roles.guard';

const routes: Routes = [
  {
    path: '',
    component: CreateProgramReportComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreateProgramReportRoutingModule { }
